export default {
  default: {
    customMobile: 'Custom Mobile',
    noMobile: 'has no mobile',
  },
}
